/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDetentionHist.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/detention-hist";

export class AutogenModelDetentionHist<RowType extends ModelRow> extends Endpoint<RowType, RowDetentionHistFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDetentionHist extends ModelRow<RowDetentionHistFields> {
	constructor(values?: Partial<RowDetentionHistFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDetentionHistFields {
	actual_arrival: Date;
	actual_departure: Date;
	arrive_msg_id: number;
	authorization_num: string;
	authorization_status: string;
	"authorization_status.company_id": string;
	"authorization_status.descr": string;
	"authorization_status.id": string;
	"authorization_status.is_active": string;
	"authorization_status.status_color": number;
	bill_approved: string;
	billing_approval: string;
	comments: string;
	commodity_id: string;
	company_id: string;
	"contact.comments": string;
	"contact.company_id": string;
	"contact.contact_name": string;
	"contact.customer_sequence": number;
	"contact.detention_contact": string;
	"contact.ect_uid": number;
	"contact.email": string;
	"contact.fax": string;
	"contact.id": string;
	"contact.is_active": string;
	"contact.is_primary_contact": string;
	"contact.is_sms_opted_in": string;
	"contact.mobile_phone": string;
	"contact.name": string;
	"contact.opt_out_date": Date;
	"contact.parent_row_id": string;
	"contact.parent_row_type": string;
	"contact.payable_contact": string;
	"contact.personal_ref": string;
	"contact.phone": string;
	"contact.rapid_alert_notify": string;
	"contact.rec_interval": number;
	"contact.rec_next_date": Date;
	"contact.rec_ops_user_id": string;
	"contact.rec_salesperson_id": string;
	"contact.sequence": number;
	"contact.terms_contact": string;
	"contact.title": string;
	"contact.type_of": string;
	"contact.verification_edit_by": string;
	"contact.verification_edit_date": Date;
	"contact.verification_status": string;
	"contact.web_access": string;
	create_charge: string;
	creation_date: Date;
	"customer.activity_count": number;
	"customer.activity_start_date": Date;
	"customer.add_empty_distance_occ": string;
	"customer.add_finance_charge": string;
	"customer.address1": string;
	"customer.address2": string;
	"customer.allow_inc_in_frt": string;
	"customer.allow_web_tendering": string;
	"customer.auto_rate": string;
	"customer.auto_tax": string;
	"customer.available_template": number;
	"customer.average_bill": number;
	"customer.average_bill_c": string;
	"customer.average_bill_d": Date;
	"customer.average_bill_n": number;
	"customer.average_bill_r": number;
	"customer.average_pay_days": number;
	"customer.balance": number;
	"customer.balance_c": string;
	"customer.balance_d": Date;
	"customer.balance_n": number;
	"customer.balance_r": number;
	"customer.benchmark_ctg_uid": number;
	"customer.benchmark_tar_uid": number;
	"customer.bill_due_days": number;
	"customer.bill_format_flag": string;
	"customer.bill_template": number;
	"customer.bill_transfer_when": string;
	"customer.billed_loads": number;
	"customer.bl_logo": string;
	"customer.bl_logo_name": string;
	"customer.blanket_buy_tariff_id": string;
	"customer.blanket_sell_tariff_id": string;
	"customer.bridge_id": string;
	"customer.brokerage_filter": string;
	"customer.business_hours": string;
	"customer.business_number": string;
	"customer.buy_tariff_id": string;
	"customer.carrier_scorecard_exported": string;
	"customer.category": string;
	"customer.cert_of_ins_date": Date;
	"customer.charge_detention": string;
	"customer.chassis_chargeby": string;
	"customer.chassis_freedays": number;
	"customer.chassis_rate": number;
	"customer.chassis_rate_c": string;
	"customer.chassis_rate_d": Date;
	"customer.chassis_rate_n": number;
	"customer.chassis_rate_r": number;
	"customer.city": string;
	"customer.city_id": number;
	"customer.coll_thresh_pd1": number;
	"customer.coll_thresh_pd1_c": string;
	"customer.coll_thresh_pd1_d": Date;
	"customer.coll_thresh_pd1_n": number;
	"customer.coll_thresh_pd1_r": number;
	"customer.coll_thresh_pd2": number;
	"customer.coll_thresh_pd2_c": string;
	"customer.coll_thresh_pd2_d": Date;
	"customer.coll_thresh_pd2_n": number;
	"customer.coll_thresh_pd2_r": number;
	"customer.coll_thresh_pd3": number;
	"customer.coll_thresh_pd3_c": string;
	"customer.coll_thresh_pd3_d": Date;
	"customer.coll_thresh_pd3_n": number;
	"customer.coll_thresh_pd3_r": number;
	"customer.coll_thresh_pd4": number;
	"customer.coll_thresh_pd4_c": string;
	"customer.coll_thresh_pd4_d": Date;
	"customer.coll_thresh_pd4_n": number;
	"customer.coll_thresh_pd4_r": number;
	"customer.collections_id": string;
	"customer.collections_ok": string;
	"customer.company_id": string;
	"customer.confidence_level": number;
	"customer.container_chargeby": string;
	"customer.container_freedays": number;
	"customer.container_rate": number;
	"customer.container_rate_c": string;
	"customer.container_rate_d": Date;
	"customer.container_rate_n": number;
	"customer.container_rate_r": number;
	"customer.contract_cbc": string;
	"customer.contract_ccc": string;
	"customer.contract_gbc": string;
	"customer.contract_gcc": string;
	"customer.contract_sbc": string;
	"customer.contract_scc": string;
	"customer.controlling_carrier_code": string;
	"customer.conversion_date": Date;
	"customer.cost_ctg_uid": number;
	"customer.cost_tar_uid": number;
	"customer.covered_template": number;
	"customer.cp_logo": string;
	"customer.cp_logo_name": string;
	"customer.credit_application": string;
	"customer.credit_check_date": Date;
	"customer.credit_limit": number;
	"customer.credit_limit_c": string;
	"customer.credit_limit_d": Date;
	"customer.credit_limit_n": number;
	"customer.credit_limit_r": number;
	"customer.credit_status": string;
	"customer.credit_warning_pct": number;
	"customer.ctg_uid": number;
	"customer.currency_type": string;
	"customer.cust_requestor_load_id": string;
	"customer.cust_stmt_template": number;
	"customer.d_and_b_code": string;
	"customer.d_and_b_date": Date;
	"customer.d_and_b_number": string;
	"customer.days_between_calls": number;
	"customer.deadhead_target": number;
	"customer.ded_last_fixed_cost_billdt": Date;
	"customer.dedicated_cycle": string;
	"customer.dedicated_revenue_code_id": string;
	"customer.dedicated_seg_alloc_code": string;
	"customer.dedicated_start_day": string;
	"customer.dedicated_template": number;
	"customer.def_rate_confirm_temp": number;
	"customer.delivered_template": number;
	"customer.departure_date_at": string;
	"customer.disable_automatic_tracking": string;
	"customer.display_eta": string;
	"customer.display_ysplit_stops": string;
	"customer.distance_method": string;
	"customer.distance_profile": string;
	"customer.distance_source": string;
	"customer.distance_type": string;
	"customer.dot_number": string;
	"customer.driver_load": string;
	"customer.empty_distance_charge_id": string;
	"customer.empty_distance_rate": number;
	"customer.enable_notifications": string;
	"customer.enforce_dep_dates": string;
	"customer.entered_date": Date;
	"customer.excise_taxable": string;
	"customer.expected_close": Date;
	"customer.extend_rates": string;
	"customer.factor_percent": number;
	"customer.factor_receivables": string;
	"customer.factoring_id": string;
	"customer.fak_profile_id": string;
	"customer.fourkites_customer_id": string;
	"customer.fuel_amount": number;
	"customer.fuel_base_price": number;
	"customer.fuel_credit": string;
	"customer.fuel_method": string;
	"customer.fuel_percent": number;
	"customer.fuel_price_region": string;
	"customer.fuel_surcharge_id": string;
	"customer.fuel_surchg_enddt": Date;
	"customer.fuel_surchg_strtdt": Date;
	"customer.fuel_variance": number;
	"customer.global_detention": string;
	"customer.google_place_id": string;
	"customer.gp_exclude": string;
	"customer.gp_exported": Date;
	"customer.gp_imported": Date;
	"customer.grace_period": number;
	"customer.high_balance": number;
	"customer.high_balance_c": string;
	"customer.high_balance_d": Date;
	"customer.high_balance_n": number;
	"customer.high_balance_r": number;
	"customer.ic_company_id": string;
	"customer.id": string;
	"customer.include_by_date": string;
	"customer.include_empty_distance": string;
	"customer.include_fuel_surcharge": string;
	"customer.include_split_point": string;
	"customer.integration_type": string;
	"customer.invoice_processing_id": string;
	"customer.is_active": string;
	"customer.is_consignee": string;
	"customer.is_distribution_center": string;
	"customer.is_drop_yard": string;
	"customer.is_geocoded": string;
	"customer.is_intercompany": string;
	"customer.is_pallets_required": string;
	"customer.is_shipper": string;
	"customer.is_trailer_pool_required": string;
	"customer.jaguar_id": number;
	"customer.last_bill_date": Date;
	"customer.last_fin_charge_dt": Date;
	"customer.last_pay_date": Date;
	"customer.last_ship_date": Date;
	"customer.latitude": number;
	"customer.location_id": string;
	"customer.longitude": number;
	"customer.macropoint_requestor_id": string;
	"customer.main_phone": string;
	"customer.manual_exchange": string;
	"customer.mark_plan_id": string;
	"customer.max_pay_percent": number;
	"customer.misc_bill_template": number;
	"customer.monthly_order_goal": number;
	"customer.motor_carrier_id": string;
	"customer.name": string;
	"customer.next_call_date": Date;
	"customer.next_rec_call": Date;
	"customer.nxt_action_code_id": string;
	"customer.nxt_action_date": Date;
	"customer.operations_user": string;
	"customer.order_count": number;
	"customer.order_detail_at": string;
	"customer.order_start_date": Date;
	"customer.override_max_city_radius": number;
	"customer.p44_profile_id": string;
	"customer.paid_loads": number;
	"customer.pay_days_date": Date;
	"customer.pay_days_orders": number;
	"customer.payee_id": string;
	"customer.pd0_alert": number;
	"customer.pd1_np_auto": string;
	"customer.pd1_sp_auto": string;
	"customer.pd1_sp_thresh": number;
	"customer.pd1_sp_thresh_c": string;
	"customer.pd1_sp_thresh_d": Date;
	"customer.pd1_sp_thresh_n": number;
	"customer.pd1_sp_thresh_r": number;
	"customer.pd2_np_auto": string;
	"customer.pd2_sp_auto": string;
	"customer.pd2_sp_thresh": number;
	"customer.pd2_sp_thresh_c": string;
	"customer.pd2_sp_thresh_d": Date;
	"customer.pd2_sp_thresh_n": number;
	"customer.pd2_sp_thresh_r": number;
	"customer.pd3_np_auto": string;
	"customer.pd3_sp_auto": string;
	"customer.pd3_sp_thresh": number;
	"customer.pd3_sp_thresh_c": string;
	"customer.pd3_sp_thresh_d": Date;
	"customer.pd3_sp_thresh_n": number;
	"customer.pd3_sp_thresh_r": number;
	"customer.pd4_np_auto": string;
	"customer.pd4_sp_auto": string;
	"customer.pd4_sp_thresh": number;
	"customer.pd4_sp_thresh_c": string;
	"customer.pd4_sp_thresh_d": Date;
	"customer.pd4_sp_thresh_n": number;
	"customer.pd4_sp_thresh_r": number;
	"customer.plc_uid": number;
	"customer.post_summary_dtl": string;
	"customer.potential": number;
	"customer.potential_c": string;
	"customer.potential_d": Date;
	"customer.potential_n": number;
	"customer.potential_r": number;
	"customer.prev_code": string;
	"customer.primary_agency": string;
	"customer.primary_commodity_id": string;
	"customer.primary_contact": string;
	"customer.primary_sort": string;
	"customer.primary_trailer_type": string;
	"customer.print_containers": string;
	"customer.progress_template": number;
	"customer.prospect_type_id": string;
	"customer.quebec_number": string;
	"customer.quote_days_to_expire": number;
	"customer.rate_override_nmfc_code": string;
	"customer.reassign_profile_id": string;
	"customer.rec_call_days": number;
	"customer.remarks": string;
	"customer.require_tracking": string;
	"customer.required_vendor": string;
	"customer.revenue": number;
	"customer.revenue_c": string;
	"customer.revenue_d": Date;
	"customer.revenue_n": number;
	"customer.revenue_r": number;
	"customer.revenue_start_date": Date;
	"customer.routing_guide_profile_id": string;
	"customer.sales_manager_id": string;
	"customer.sales_status_id": string;
	"customer.salesperson_id": string;
	"customer.search_city": string;
	"customer.search_state_id": string;
	"customer.search_zip_code": string;
	"customer.secondary_sort": string;
	"customer.sell_tariff_id": string;
	"customer.service_fail_cons": string;
	"customer.service_fail_drop": string;
	"customer.service_fail_pick": string;
	"customer.service_fail_ship": string;
	"customer.service_failures": string;
	"customer.service_failures_review": string;
	"customer.shipment_ident_type": string;
	"customer.sic_code": string;
	"customer.smc3_profile_id": string;
	"customer.start_date": Date;
	"customer.state_id": string;
	"customer.summary_billing": string;
	"customer.summary_template": number;
	"customer.tar_uid": number;
	"customer.target_profit": number;
	"customer.tenfour_customer_id": string;
	"customer.toll_oc_exempt": string;
	"customer.tracking_hours_prior": number;
	"customer.trimble_place_id": string;
	"customer.type_of": string;
	"customer.use_local_mile": string;
	"customer.vm_part_update": string;
	"customer.waterfall_auto_route_guides": string;
	"customer.waterfall_lead_time": number;
	"customer.waterfall_notify_email": string;
	"customer.waterfall_process": string;
	"customer.website_url": string;
	"customer.wf_auto_renbill": string;
	"customer.wf_autobill": string;
	"customer.wf_bwop": string;
	"customer.wf_queue": number;
	"customer.zip_code": string;
	"customer.zone_id": string;
	customer_id: string;
	depart_msg_id: number;
	"detention_def.always_pay": string;
	"detention_def.applies_to": string;
	"detention_def.apply_to_confirmed_appts": string;
	"detention_def.billing_approval": string;
	"detention_def.carrier_earning_code": string;
	"detention_def.carrier_max_pay_amount": number;
	"detention_def.carrier_max_pay_amount_c": string;
	"detention_def.carrier_max_pay_amount_d": Date;
	"detention_def.carrier_max_pay_amount_n": number;
	"detention_def.carrier_max_pay_amount_r": number;
	"detention_def.carrier_method": string;
	"detention_def.carrier_pay_option": string;
	"detention_def.carrier_pay_rate": number;
	"detention_def.cmp_driver_earning_code": string;
	"detention_def.cmp_driver_max_pay_amount": number;
	"detention_def.cmp_driver_max_pay_amount_c": string;
	"detention_def.cmp_driver_max_pay_amount_d": Date;
	"detention_def.cmp_driver_max_pay_amount_n": number;
	"detention_def.cmp_driver_max_pay_amount_r": number;
	"detention_def.cmp_driver_method": string;
	"detention_def.cmp_driver_pay_rate": number;
	"detention_def.cmp_pay_option": string;
	"detention_def.cmp_team_earning_code": string;
	"detention_def.cmp_team_max_pay_amount": number;
	"detention_def.cmp_team_max_pay_amount_c": string;
	"detention_def.cmp_team_max_pay_amount_d": Date;
	"detention_def.cmp_team_max_pay_amount_n": number;
	"detention_def.cmp_team_max_pay_amount_r": number;
	"detention_def.cmp_team_method": string;
	"detention_def.cmp_team_pay_rate": number;
	"detention_def.commodity_id": string;
	"detention_def.company_id": string;
	"detention_def.contact_name": string;
	"detention_def.customer_id": string;
	"detention_def.descr": string;
	"detention_def.early_arrival_hours": number;
	"detention_def.early_arrival_minutes": number;
	"detention_def.effective_date": Date;
	"detention_def.email_billing": string;
	"detention_def.email_cc_list": string;
	"detention_def.email_errors": string;
	"detention_def.email_list": string;
	"detention_def.email_profile_id": string;
	"detention_def.email_reply": string;
	"detention_def.expiration_date": Date;
	"detention_def.fax_no": string;
	"detention_def.free_time_hours": number;
	"detention_def.free_time_minutes": number;
	"detention_def.freq_chg_hours": number;
	"detention_def.freq_chg_minutes": number;
	"detention_def.freq_warn_hours": number;
	"detention_def.freq_warn_minutes": number;
	"detention_def.global_definition": string;
	"detention_def.grace_period": number;
	"detention_def.id": number;
	"detention_def.is_active": string;
	"detention_def.late_arrivals": string;
	"detention_def.maximum_amount": number;
	"detention_def.maximum_amount_c": string;
	"detention_def.maximum_amount_d": Date;
	"detention_def.maximum_amount_n": number;
	"detention_def.maximum_amount_r": number;
	"detention_def.notify_arrival": string;
	"detention_def.notify_charge": string;
	"detention_def.notify_departure": string;
	"detention_def.notify_warning": string;
	"detention_def.order_type_id": string;
	"detention_def.ownop_earning_code": string;
	"detention_def.ownop_max_pay_amount": number;
	"detention_def.ownop_max_pay_amount_c": string;
	"detention_def.ownop_max_pay_amount_d": Date;
	"detention_def.ownop_max_pay_amount_n": number;
	"detention_def.ownop_max_pay_amount_r": number;
	"detention_def.ownop_method": string;
	"detention_def.ownop_pay_option": string;
	"detention_def.ownop_pay_rate": number;
	"detention_def.pay_free_time_hours": number;
	"detention_def.pay_free_time_minutes": number;
	"detention_def.priority": number;
	"detention_def.require_auth": string;
	"detention_def.revenue_code_id": string;
	"detention_def.rounding_option": string;
	"detention_def.stop_location_id": string;
	"detention_def.text_arrival": string;
	"detention_def.text_charge": string;
	"detention_def.text_departure": string;
	"detention_def.text_warning": string;
	"detention_def.use_actual_time": string;
	"detention_def.use_showas_location": string;
	"detention_def.warn_hours": number;
	"detention_def.warn_minutes": number;
	detention_def_id: string;
	driver2_id: string;
	driver_id: string;
	free_time_end: Date;
	free_time_remaining: string;
	free_time_starts: Date;
	id: string;
	loaded_time: Date;
	"location.address1": string;
	"location.address2": string;
	"location.appt_required": string;
	"location.assigned_to": string;
	"location.bseg": string;
	"location.category": string;
	"location.cbsa_port_id": string;
	"location.chassis_owner": string;
	"location.chassis_pool": string;
	"location.city_id": number;
	"location.city_name": string;
	"location.class_rqmt": string;
	"location.comments": string;
	"location.company_id": string;
	"location.container_pool": string;
	"location.container_vendor": string;
	"location.cust_id": string;
	"location.customer_id": string;
	"location.days_between_calls": number;
	"location.ded_rqmt_type": string;
	"location.ded_type": string;
	"location.def_commodity_desc": string;
	"location.def_commodity_id": string;
	"location.delivery_date_option": string;
	"location.directions": string;
	"location.disable_loc_rating": string;
	"location.dl_gen_cost": number;
	"location.dl_gen_repower": number;
	"location.dl_haz_cost": number;
	"location.dl_haz_repower": number;
	"location.dl_hvl_cost": number;
	"location.dl_hvl_repower": number;
	"location.dl_load_time": number;
	"location.dl_svc_cost": number;
	"location.dl_svc_repower": number;
	"location.dl_unload_time": number;
	"location.driver_load_id": string;
	"location.driver_unload_id": string;
	"location.ds_capacity_cost": number;
	"location.ds_model_flag": string;
	"location.extra_handling_time": number;
	"location.filer_code": string;
	"location.foreign_port": string;
	"location.friday_close": Date;
	"location.friday_open": Date;
	"location.fuel_price_region": string;
	"location.google_place_fm_address": string;
	"location.google_place_id": string;
	"location.google_place_type": string;
	"location.id": string;
	"location.include_xref_trailers": string;
	"location.insur_amt_rqrd": number;
	"location.insur_amt_rqrd_c": string;
	"location.insur_amt_rqrd_d": Date;
	"location.insur_amt_rqrd_n": number;
	"location.insur_amt_rqrd_r": number;
	"location.is_active": string;
	"location.is_consignee": string;
	"location.is_customer": string;
	"location.is_customs_broker": string;
	"location.is_dist_center": string;
	"location.is_dl_gen": string;
	"location.is_dl_haz": string;
	"location.is_dl_hvl": string;
	"location.is_dl_svc": string;
	"location.is_drop_yard": string;
	"location.is_geocoded": string;
	"location.is_outside_terminal": string;
	"location.is_prospect": string;
	"location.is_remote_terminal": string;
	"location.is_shipper": string;
	"location.is_steamship": string;
	"location.is_terminal": string;
	"location.is_trailer_pool": string;
	"location.is_trailer_wash": string;
	"location.is_truckstop": string;
	"location.last_used_date": Date;
	"location.latitude": number;
	"location.layover": string;
	"location.load_unload_count": number;
	"location.load_unload_excl": string;
	"location.load_unload_param": string;
	"location.loading_instructs": string;
	"location.loading_time": number;
	"location.longitude": number;
	"location.ltl_optimize_time_per_spot": number;
	"location.ltl_seg_alloc_code": string;
	"location.manual_exchange": string;
	"location.max_drvr_complaint": number;
	"location.max_pallet_balance": number;
	"location.max_payment_code_amt": number;
	"location.max_payment_code_amt_c": string;
	"location.max_payment_code_amt_d": Date;
	"location.max_payment_code_amt_n": number;
	"location.max_payment_code_amt_r": number;
	"location.model_flag": string;
	"location.monday_close": Date;
	"location.monday_open": Date;
	"location.name": string;
	"location.need_clean_trailer": string;
	"location.next_call_date": Date;
	"location.no_fuel_radius_inbound": number;
	"location.no_fuel_radius_outbound": number;
	"location.no_stop_miles": number;
	"location.on_duty_not_driving_mins": number;
	"location.pallet_balance": number;
	"location.pallets_required": string;
	"location.payment_api_excluded": string;
	"location.pickup_date_option": string;
	"location.plc_uid": number;
	"location.pnn_city_id": number;
	"location.pnn_city_name": string;
	"location.pnn_state": string;
	"location.pnn_zip_code": string;
	"location.port_id": string;
	"location.prev_code": string;
	"location.primary_agency": string;
	"location.radius": number;
	"location.regulated": string;
	"location.reload_rqmt": string;
	"location.reserve_mins": number;
	"location.salesperson": string;
	"location.saturday_close": Date;
	"location.saturday_open": Date;
	"location.shuttle_capacity": string;
	"location.state": string;
	"location.sunday_close": Date;
	"location.sunday_open": Date;
	"location.swap_cost": number;
	"location.team_rqmt": string;
	"location.thursday_close": Date;
	"location.thursday_open": Date;
	"location.trailer_pool_min": number;
	"location.trailer_pool_radius": number;
	"location.trailer_pool_size": number;
	"location.trailer_wash_vend": string;
	"location.trimble_place_id": string;
	"location.trip_starter": string;
	"location.tuesday_close": Date;
	"location.tuesday_open": Date;
	"location.tw_seg_code": string;
	"location.unload_instructs": string;
	"location.unloading_time": number;
	"location.website_url": string;
	"location.wednesday_close": Date;
	"location.wednesday_open": Date;
	"location.zip_code": string;
	"movement.additional_customer_tag": string;
	"movement.additional_global_tag": string;
	"movement.authorized": string;
	"movement.average_broker_rating": number;
	"movement.booking_no": string;
	"movement.br_details_link": string;
	"movement.br_status_link": string;
	"movement.br_track_interval": number;
	"movement.br_track_status": string;
	"movement.br_track_status_desc": string;
	"movement.br_track_vehicle_id": string;
	"movement.br_tracking_id": string;
	"movement.br_vendor": string;
	"movement.broker_avail_tract": string;
	"movement.brokerage": string;
	"movement.brokerage_status": string;
	"movement.buy_to_market_ex": string;
	"movement.carrier_contact": string;
	"movement.carrier_email": string;
	"movement.carrier_empty_from_city_id": number;
	"movement.carrier_fuel_pay_rate_id": number;
	"movement.carrier_lane_rate_id": string;
	"movement.carrier_override_carrier": string;
	"movement.carrier_override_user": string;
	"movement.carrier_phone": string;
	"movement.carrier_rate_id": number;
	"movement.carrier_scorecard_export_dt": Date;
	"movement.carrier_scorecard_exported": string;
	"movement.carrier_tractor": string;
	"movement.carrier_trailer": string;
	"movement.carrier_trailer_type": string;
	"movement.chassis": string;
	"movement.checkcall_sched_id": string;
	"movement.company_id": string;
	"movement.container": string;
	"movement.container_returned": string;
	"movement.container_status": string;
	"movement.controlling_carrier_code": string;
	"movement.dedicated_order_id": string;
	"movement.dest_stop_id": string;
	"movement.dfm_user": string;
	"movement.digital_booking": string;
	"movement.dispatcher_user_id": string;
	"movement.eform_rate_confirmation": string;
	"movement.empty2next_order": string;
	"movement.equipment_group_id": string;
	"movement.est_tolls": number;
	"movement.est_tolls_c": string;
	"movement.est_tolls_d": Date;
	"movement.est_tolls_n": number;
	"movement.est_tolls_r": number;
	"movement.exclude_movement": string;
	"movement.fleet_manager": string;
	"movement.freight_matching_override": string;
	"movement.fuel_distance": number;
	"movement.fuel_distance_um": string;
	"movement.fuel_tax_exempt": string;
	"movement.has_load_lock_alert": string;
	"movement.hubtran_approved_inv_date": Date;
	"movement.hubtran_ok2pay_date": Date;
	"movement.ic_company_to": string;
	"movement.ic_order_to": string;
	"movement.id": string;
	"movement.integrated_carrier_search": string;
	"movement.invitation_date": Date;
	"movement.invoice_recv_date": Date;
	"movement.is_container": string;
	"movement.is_dfm_tracking": string;
	"movement.is_dray": string;
	"movement.is_intercompany": string;
	"movement.is_local_mile": string;
	"movement.linked_id": number;
	"movement.linked_sequence": number;
	"movement.load_booking_eligible": string;
	"movement.load_booking_source": string;
	"movement.loaded": string;
	"movement.locked_user_id": string;
	"movement.ltl": string;
	"movement.ltl_staging_wrs_uid": number;
	"movement.macropoint_status": string;
	"movement.manifest_empty_distance": number;
	"movement.manifest_estimated_arrival": Date;
	"movement.manifest_estimated_depart": Date;
	"movement.manifest_hold": string;
	"movement.manifest_id": string;
	"movement.manifest_loaded_distance": number;
	"movement.manifest_reg_uid": number;
	"movement.manifest_spots_capacity": number;
	"movement.manifest_spots_consumed": number;
	"movement.manifest_weight_capacity": number;
	"movement.manifest_weight_consumed": number;
	"movement.max_buy": number;
	"movement.max_buy_c": string;
	"movement.max_buy_d": Date;
	"movement.max_buy_n": number;
	"movement.max_buy_r": number;
	"movement.max_pay_method": string;
	"movement.max_pay_units": number;
	"movement.missed_call_sent": string;
	"movement.move_distance": number;
	"movement.move_distance_um": string;
	"movement.movement_type": string;
	"movement.must_respond_by": Date;
	"movement.next_sched_call": Date;
	"movement.operational_status": string;
	"movement.operations_user": string;
	"movement.origin_stop_id": string;
	"movement.override_crny_type": string;
	"movement.override_driver2_id": number;
	"movement.override_driver2_nm": string;
	"movement.override_driver_id": number;
	"movement.override_driver_nm": string;
	"movement.override_drvr2_cell": string;
	"movement.override_drvr2_country_code": string;
	"movement.override_drvr2_email": string;
	"movement.override_drvr_cell": string;
	"movement.override_drvr_country_code": string;
	"movement.override_drvr_email": string;
	"movement.override_max_pay": number;
	"movement.override_max_pay_c": string;
	"movement.override_max_pay_d": Date;
	"movement.override_max_pay_n": number;
	"movement.override_max_pay_r": number;
	"movement.override_pay_amt": number;
	"movement.override_pay_amt_c": string;
	"movement.override_pay_amt_d": Date;
	"movement.override_pay_amt_n": number;
	"movement.override_pay_amt_r": number;
	"movement.override_pay_rate": number;
	"movement.override_paye_rate": number;
	"movement.override_payee_id": string;
	"movement.override_targetpay": number;
	"movement.override_targetpay_c": string;
	"movement.override_targetpay_d": Date;
	"movement.override_targetpay_n": number;
	"movement.override_targetpay_r": number;
	"movement.override_type": string;
	"movement.override_unit_desc": string;
	"movement.override_units": number;
	"movement.pay_distance": number;
	"movement.pay_distance_um": string;
	"movement.pending_carrier_city": string;
	"movement.pending_carrier_name": string;
	"movement.pending_carrier_nbr": string;
	"movement.pending_carrier_phone": string;
	"movement.pending_carrier_state": string;
	"movement.pending_carrier_type": string;
	"movement.pending_carrier_zip": string;
	"movement.pending_invite_conf": string;
	"movement.pending_payee_id": string;
	"movement.placard_required": string;
	"movement.preassign_sequence": number;
	"movement.priority": string;
	"movement.pro_nbr": string;
	"movement.rate_alert_basis": string;
	"movement.rate_alert_date": Date;
	"movement.rate_alert_days": number;
	"movement.rate_alert_hours": number;
	"movement.rate_alert_minutes": number;
	"movement.rate_confirm_template": number;
	"movement.rate_confirmation_sent_date": Date;
	"movement.rate_confirmation_status": string;
	"movement.rate_expiration_basis": string;
	"movement.rate_expiration_date": Date;
	"movement.rate_expiration_days": number;
	"movement.rate_expiration_hours": number;
	"movement.rate_expiration_minutes": number;
	"movement.rdy_pickup_date": Date;
	"movement.recurring_movement_id": string;
	"movement.reminder_sent": string;
	"movement.require_tracking": string;
	"movement.required_vendor": string;
	"movement.reserved": string;
	"movement.return_date": Date;
	"movement.seg_alloc_code": string;
	"movement.shipper_email": string;
	"movement.shipper_notify_frequency": string;
	"movement.shpmt_ident_type": string;
	"movement.shpmt_ident_value": string;
	"movement.ss_location_id": string;
	"movement.status": string;
	"movement.target_extra_stop_pay": number;
	"movement.target_extra_stop_pay_c": string;
	"movement.target_extra_stop_pay_d": Date;
	"movement.target_extra_stop_pay_n": number;
	"movement.target_extra_stop_pay_r": number;
	"movement.target_fuel_surcharge_pay": string;
	"movement.target_pay": number;
	"movement.target_pay_c": string;
	"movement.target_pay_d": Date;
	"movement.target_pay_method": string;
	"movement.target_pay_n": number;
	"movement.target_pay_r": number;
	"movement.target_pay_units": number;
	"movement.target_rate_data": string;
	"movement.target_rate_id": number;
	"movement.time_to_send_msg": Date;
	"movement.track_start_date": Date;
	"movement.tracking_duration_ext": number;
	"movement.tracking_notify_email": string;
	"movement.tracking_request_status": string;
	"movement.trailer_rent_pct": number;
	"movement.trip_lease": string;
	"movement.trip_mgt_recalc_datetime": Date;
	"movement.trip_mgt_tracking_id": string;
	"movement.triumphpay_exclude": string;
	"movement.trp_uid": number;
	"movement.ts_borrowing_company": string;
	"movement.ts_commodity": string;
	"movement.ts_movement_id": string;
	"movement.unlock_time": Date;
	"movement.waterfall_flood_time": Date;
	"movement.waterfall_in_progress": string;
	"movement.xfer2settle_date": Date;
	"movement.xferred2fueltax": string;
	"movement.xferred2fueltaxdt": Date;
	"movement.xmit_accepted": string;
	"movement.xmitted2driver": Date;
	"movement.zmit_trip": string;
	movement_id: string;
	name: string;
	notify_arrival_dt: Date;
	notify_charge_dt: Date;
	notify_depart_dt: Date;
	notify_warn_dt: Date;
	order_id: string;
	"orders.actual_reefer_profile": string;
	"orders.agency_id": string;
	"orders.agent_payee_id": string;
	"orders.all_vendors_enabled": string;
	"orders.allow_relay": string;
	"orders.autorate_status": string;
	"orders.bill_date": Date;
	"orders.bill_distance": number;
	"orders.bill_distance_um": string;
	"orders.billing_empty_distance": number;
	"orders.billing_empty_distance_um": string;
	"orders.billing_loaded_distance": number;
	"orders.billing_loaded_distance_um": string;
	"orders.billing_user_id": string;
	"orders.blnum": string;
	"orders.bol_note": string;
	"orders.bol_received": string;
	"orders.bol_recv_date": Date;
	"orders.booking_no": string;
	"orders.booking_number": string;
	"orders.brk_qual_profile": string;
	"orders.broker_location_id": string;
	"orders.brokerage_workflow_id": string;
	"orders.carrier_scorecard_export_dt": Date;
	"orders.carrier_scorecard_exported": string;
	"orders.cbp_crossing_date": Date;
	"orders.cbp_crossing_location_id": string;
	"orders.cbp_crossing_reason": string;
	"orders.cbsa_crossing_date": Date;
	"orders.cbsa_crossing_location_id": string;
	"orders.cbsa_crossing_reason": string;
	"orders.cc_fuel_revenue": number;
	"orders.cc_fuel_revenue_c": string;
	"orders.cc_fuel_revenue_d": Date;
	"orders.cc_fuel_revenue_n": number;
	"orders.cc_fuel_revenue_r": number;
	"orders.cc_net_revenue": number;
	"orders.cc_net_revenue_c": string;
	"orders.cc_net_revenue_d": Date;
	"orders.cc_net_revenue_n": number;
	"orders.cc_net_revenue_r": number;
	"orders.cc_pro_nbr": string;
	"orders.cobroker_location_id": string;
	"orders.collection_method": string;
	"orders.com_setpnt_temp": number;
	"orders.com_setpnt_temp_dt": Date;
	"orders.com_setpnt_temp_um": string;
	"orders.commitment_id": string;
	"orders.commodity": string;
	"orders.commodity_id": string;
	"orders.company_id": string;
	"orders.consignee_refno": string;
	"orders.consignee_stop_id": string;
	"orders.container": string;
	"orders.container_planned": string;
	"orders.container_type_id": string;
	"orders.controlling_carrier_code": string;
	"orders.copy_from_company": string;
	"orders.copy_from_order_id": string;
	"orders.copy_to_company": string;
	"orders.copy_to_order_id": string;
	"orders.ctrl_party_id": string;
	"orders.cube": number;
	"orders.curr_movement_id": string;
	"orders.cust_order_no": string;
	"orders.customer_id": string;
	"orders.dat_loadboard_refid": string;
	"orders.declared_val": number;
	"orders.def_move_type": string;
	"orders.default_match_id": string;
	"orders.dim_height": string;
	"orders.dim_length": string;
	"orders.dim_surcharge": number;
	"orders.dim_surcharge_c": string;
	"orders.dim_surcharge_d": Date;
	"orders.dim_surcharge_n": number;
	"orders.dim_surcharge_r": number;
	"orders.dim_width": string;
	"orders.dispatch_opt": string;
	"orders.dl_team_reqd": string;
	"orders.dray_del_date": Date;
	"orders.dray_del_pay": number;
	"orders.dray_del_pay_c": string;
	"orders.dray_del_pay_d": Date;
	"orders.dray_del_pay_n": number;
	"orders.dray_del_pay_r": number;
	"orders.dray_del_payee": string;
	"orders.dray_del_xfer_dt": Date;
	"orders.dray_pu_date": Date;
	"orders.dray_pu_pay": number;
	"orders.dray_pu_pay_c": string;
	"orders.dray_pu_pay_d": Date;
	"orders.dray_pu_pay_n": number;
	"orders.dray_pu_pay_r": number;
	"orders.dray_pu_payee": string;
	"orders.dray_pu_xfer_dt": Date;
	"orders.eir1_no": string;
	"orders.eir2_no": string;
	"orders.entered_user_id": string;
	"orders.equipment_type_id": string;
	"orders.equipment_type_options": string;
	"orders.est_tolls": number;
	"orders.est_tolls_c": string;
	"orders.est_tolls_d": Date;
	"orders.est_tolls_n": number;
	"orders.est_tolls_r": number;
	"orders.excise_disable_update": string;
	"orders.excise_taxable": string;
	"orders.excisetax_total": number;
	"orders.excisetax_total_c": string;
	"orders.excisetax_total_d": Date;
	"orders.excisetax_total_n": number;
	"orders.excisetax_total_r": number;
	"orders.external_invoiceno": string;
	"orders.extra_deliveries": number;
	"orders.extra_pickups": number;
	"orders.floor_loaded_freight": string;
	"orders.force_assign": string;
	"orders.forwd_location_id": string;
	"orders.free_days": number;
	"orders.freight_charge": number;
	"orders.freight_charge_c": string;
	"orders.freight_charge_d": Date;
	"orders.freight_charge_n": number;
	"orders.freight_charge_r": number;
	"orders.hazmat": string;
	"orders.hazmat_code": string;
	"orders.high_value": string;
	"orders.hold_reason": string;
	"orders.ic_company_from": string;
	"orders.ic_movement_from": string;
	"orders.ic_order_from": string;
	"orders.id": string;
	"orders.image_is_present": string;
	"orders.import_export": string;
	"orders.include_split_point": string;
	"orders.intelliset": string;
	"orders.invoice_recv_date": Date;
	"orders.is_auto_tonu": string;
	"orders.is_autorate_dist": string;
	"orders.is_container": string;
	"orders.is_dedicated": string;
	"orders.is_intercompany": string;
	"orders.is_local_mile": string;
	"orders.is_requested": string;
	"orders.is_tonu": string;
	"orders.jag_carrier_id": string;
	"orders.jag_cost_rate_id": number;
	"orders.ldport_location_id": string;
	"orders.linear_feet_avail": number;
	"orders.load_date": Date;
	"orders.loadboard": string;
	"orders.loadboard_last_refresh": Date;
	"orders.loadboard_post_movement_id": string;
	"orders.loadboard_posting_cancelled": string;
	"orders.lock_miles": string;
	"orders.ltl": string;
	"orders.markup_flat": number;
	"orders.markup_flat_c": string;
	"orders.markup_flat_d": Date;
	"orders.markup_flat_n": number;
	"orders.markup_flat_r": number;
	"orders.markup_percent": number;
	"orders.master_order_id": string;
	"orders.master_sequence": number;
	"orders.next_rebill": string;
	"orders.nte_lp_num": string;
	"orders.nte_lp_qual": string;
	"orders.on_hold": string;
	"orders.operational_status": string;
	"orders.operations_user": string;
	"orders.optimize": string;
	"orders.optiset": string;
	"orders.order_length": number;
	"orders.order_mode": string;
	"orders.order_type_id": string;
	"orders.order_value": number;
	"orders.order_value_c": string;
	"orders.order_value_d": Date;
	"orders.order_value_n": number;
	"orders.order_value_r": number;
	"orders.ordered_by": string;
	"orders.ordered_by_id": string;
	"orders.ordered_date": Date;
	"orders.ordered_method": string;
	"orders.orig_dest_rate_id": string;
	"orders.otherchargetotal": number;
	"orders.otherchargetotal_c": string;
	"orders.otherchargetotal_d": Date;
	"orders.otherchargetotal_n": number;
	"orders.otherchargetotal_r": number;
	"orders.override_arrive_early": Date;
	"orders.override_arrive_late": Date;
	"orders.override_posting_city_id": number;
	"orders.pallets_how_many": number;
	"orders.pallets_required": string;
	"orders.pay_gross": number;
	"orders.pay_gross_c": string;
	"orders.pay_gross_d": Date;
	"orders.pay_gross_n": number;
	"orders.pay_gross_r": number;
	"orders.pick_up_no": string;
	"orders.pieces": number;
	"orders.placard_required": string;
	"orders.planning_comment": string;
	"orders.pnn_callback": string;
	"orders.pnn_comment": string;
	"orders.pnn_comment2": string;
	"orders.pnn_loadboard_user_id": string;
	"orders.pnn_post_type": string;
	"orders.pnn_rate": number;
	"orders.pnn_rate_type": string;
	"orders.pnn_trailer_length": number;
	"orders.pnn_trailer_width": number;
	"orders.ponum": string;
	"orders.port": string;
	"orders.port_of_discharge": string;
	"orders.preferred_vendors": string;
	"orders.preload_trailer_id": string;
	"orders.preloaded": string;
	"orders.rate": number;
	"orders.rate_currency_type": string;
	"orders.rate_id": number;
	"orders.rate_min_weight": number;
	"orders.rate_min_weight_um": string;
	"orders.rate_source": string;
	"orders.rate_type": string;
	"orders.rate_unit_desc": string;
	"orders.rate_units": number;
	"orders.ready_to_bill": string;
	"orders.recurring_order_id": string;
	"orders.reply_transmitted": string;
	"orders.requesting_company": string;
	"orders.return_temp": number;
	"orders.return_temp_dt": Date;
	"orders.return_temp_um": string;
	"orders.return_temp_var": number;
	"orders.return_temp_var_um": string;
	"orders.revenue_code_id": string;
	"orders.revenue_share_method": string;
	"orders.round_trip": string;
	"orders.sail_date": Date;
	"orders.seal_number": string;
	"orders.seg_alloc_code": string;
	"orders.setpoint_temp": number;
	"orders.setpoint_temp_um": string;
	"orders.setpoint_var": number;
	"orders.setpoint_var_um": string;
	"orders.ship_status_to_edi": string;
	"orders.shipment_id": string;
	"orders.shipper_stop_id": string;
	"orders.shipstatus2edi_dt": Date;
	"orders.ss_location_id": string;
	"orders.status": string;
	"orders.subject_order_number": string;
	"orders.subject_order_status": string;
	"orders.subject_order_void_date": Date;
	"orders.swap": string;
	"orders.teams_required": string;
	"orders.temperature_max": number;
	"orders.temperature_max_um": string;
	"orders.temperature_min": number;
	"orders.temperature_min_um": string;
	"orders.temperature_um": string;
	"orders.total_charge": number;
	"orders.total_charge_c": string;
	"orders.total_charge_d": Date;
	"orders.total_charge_n": number;
	"orders.total_charge_r": number;
	"orders.totalcharge_and_excisetax": number;
	"orders.totalcharge_and_excisetax_c": string;
	"orders.totalcharge_and_excisetax_d": Date;
	"orders.totalcharge_and_excisetax_n": number;
	"orders.totalcharge_and_excisetax_r": number;
	"orders.tractor_type": string;
	"orders.vessel": string;
	"orders.vessel_cutoff_date": Date;
	"orders.voided_load_transmitted": string;
	"orders.voided_load_transmitted_dt": Date;
	"orders.weight": number;
	"orders.weight_um": string;
	"orders.xferred2billing": string;
	"orders.xferred2billing_dt": Date;
	pay_approval: string;
	pay_free_time_end: Date;
	require_auth: string;
	sched_arrival: Date;
	sched_arrive_early: Date;
	sched_arrive_late: Date;
	showas_address: string;
	showas_address2: string;
	showas_city_id: number;
	showas_city_name: string;
	showas_location_id: string;
	showas_location_name: string;
	showas_state: string;
	showas_zip_code: string;
	status: string;
	"stop.actual_arrival": Date;
	"stop.actual_departure": Date;
	"stop.address": string;
	"stop.address2": string;
	"stop.appointment_status_id": string;
	"stop.appt_contact_name": string;
	"stop.appt_required": string;
	"stop.cases": number;
	"stop.city_id": number;
	"stop.city_name": string;
	"stop.company_id": string;
	"stop.confirmed": string;
	"stop.contact_email": string;
	"stop.contact_name": string;
	"stop.dist_from_prev": number;
	"stop.dist_from_prev_um": string;
	"stop.driver_load_unload": string;
	"stop.edi_code": string;
	"stop.edi_loc_code": string;
	"stop.eta": Date;
	"stop.eta_distance": number;
	"stop.eta_late": string;
	"stop.eta_oor": string;
	"stop.google_place_id": string;
	"stop.grouped_id": number;
	"stop.hub": number;
	"stop.ic_stop_id": string;
	"stop.id": string;
	"stop.inbound_status": string;
	"stop.late_eta_colorcode": string;
	"stop.late_route_status": string;
	"stop.latitude": number;
	"stop.location_id": string;
	"stop.location_name": string;
	"stop.longitude": number;
	"stop.manifest_fgp_uid": number;
	"stop.manifest_reg_uid": number;
	"stop.move_dist_from_preassign": number;
	"stop.move_dist_from_preassign_um": string;
	"stop.move_dist_from_previous": number;
	"stop.move_dist_from_previous_um": string;
	"stop.movement_id": string;
	"stop.movement_sequence": number;
	"stop.operational_status": string;
	"stop.order_id": string;
	"stop.order_sequence": number;
	"stop.orig_sched_early": Date;
	"stop.orig_sched_late": Date;
	"stop.pallets_dropped": number;
	"stop.pallets_picked_up": number;
	"stop.payment_code_reviewed": string;
	"stop.phone": string;
	"stop.planned_arrival_time": Date;
	"stop.ponum": string;
	"stop.prior_uncleared_stops": string;
	"stop.projected_arrival": Date;
	"stop.pu_override_arrive_early": Date;
	"stop.pu_override_arrive_late": Date;
	"stop.rate_dist_from_previous": number;
	"stop.rate_dist_from_previous_um": string;
	"stop.refno": string;
	"stop.requested_service": string;
	"stop.sched_arrive_early": Date;
	"stop.sched_arrive_late": Date;
	"stop.seal": string;
	"stop.service_date": Date;
	"stop.showas_address": string;
	"stop.showas_address2": string;
	"stop.showas_city_id": number;
	"stop.showas_city_name": string;
	"stop.showas_location_id": string;
	"stop.showas_location_name": string;
	"stop.showas_state": string;
	"stop.showas_zip_code": string;
	"stop.signed_for_name": string;
	"stop.state": string;
	"stop.status": string;
	"stop.stop_type": string;
	"stop.trimble_place_id": string;
	"stop.txl_uid": number;
	"stop.volume": number;
	"stop.volume_um": string;
	"stop.weight": number;
	"stop.weight_um": string;
	"stop.zip_code": string;
	"stop.zone_id": string;
	stop_address: string;
	stop_city_id: number;
	stop_city_name: string;
	stop_id: string;
	stop_latitude: number;
	stop_location_id: string;
	stop_location_name: string;
	stop_longitude: number;
	stop_movement_sequence: number;
	stop_state: string;
	stop_time_offset: string;
	stop_timezone: string;
	stop_type: string;
	stop_zip_code: string;
	total_detention: string;
	tractor_id: string;
	trailer_id: string;
}

